module.exports = __webpack_public_path__ + "img/NMK-teaser-front.24280848.png";